import { convertCentsToDollars } from '@/utils/currency';
import FormFields from '../constants/FormFields';
import type FormDataType from '../types/FormDataType';

const FORM_FIELD_NAMES: string[] = Object.values(FormFields);

// Copies over automation values to appropriate form fields and converts
// donation values from dollars to cents if defined.
const mapAutomationToFormData = (
  automation: MajorGiftAutomation,
): FormDataType =>
  Object.entries(automation).reduce((obj, [key, val]) => {
    if (!FORM_FIELD_NAMES.includes(key)) return obj;
    let value = val;
    if (
      val &&
      (key === FormFields.MIN_DONATION || key === FormFields.MAX_DONATION)
    ) {
      value = convertCentsToDollars(val);
    }
    return {
      ...obj,
      [key]: value,
    };
  }, {});

export default mapAutomationToFormData;
